import { Widget } from '@sprinklr/stories/widget/Widget';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';

export const WidgetCustomRichText: Widget = {
    type: 'customContentRichText',
    id: '1',
    name: 'Rich Text',
    position: {
        grid: {
            enabled: true,
            columns: {
                start: 3,
                end: 9,
            },
            rows: {
                start: 2,
                end: 3,
            },
        },
    },
    label: {
        titleText: 'Rich Text',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    options: {
        player: {
            playing: false,
            duration: 15,
        },
        contentRichText: {
            entityMap: {},
            inheritFontCase: false,
            blocks: [
                {
                    key:
                        'key_' +
                        Math.random()
                            .toString(36)
                            .substr(2, 9),
                    text: 'Rich Text',
                    type: 'unstyled',
                    depth: 0,
                    inlineStyleRanges: [
                        {
                            offset: 0,
                            length: 9,
                            style: 'CUSTOM_FONT_SIZE_20' as any,
                        },
                    ],
                    entityRanges: [],
                    data: {},
                },
            ],
        },
    },
};
